import { AppLayout, Logo } from "uikit"
import React, { lazy, useState, useEffect } from "react"
import {
  Redirect,
  Route,
  Switch,
  withRouter,
  useLocation
} from "react-router-dom"
import { useStore } from "store"
import Agreements from "./Agreements"
import InviteCode from "./InviteCode"
import FindYourEmployer from "./FindYourEmployer"
import { OverviewDirectFree } from "./OverviewDirectFree"
import { plans } from "./plans"
import PlanSelector from "./PlanSelector"
import StripeCheckout from "./StripeCheckout"
import { OverviewInvited } from "./OverviewInvited"
import { OverviewDirectPaid } from "./OverviewDirectPaid"
import { OverviewDirectPersonal } from "./OverviewDirectPersonal"
import { OverviewCOVID } from "./OverviewCOVID"
import TermsofUse from "components/TermsofUse"
import { useHistory } from "react-router"

const ProfileInfo = lazy(() => import("./ProfileInfo"))
const Recaptcha = lazy(() => import("components/Recaptcha"))

const IS_PREMIUM =
  document &&
  document.cookie.replace(
    /(?:(?:^|.*;\s*)isPremium\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  ) === "true"

const SignupContainer = props => {
  const history = useHistory()
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [stripe_token, setStripe_token] = useState(null)
  const [acceptedAgreements, setAcceptedAgreements] = useState([])
  const [invite_code, setInvite_code] = useState(props.invite_code || null)
  const [invalidInvite, setInvalidInvite] = useState(false)
  const { search } = useLocation()

  const isBenalign = search === "?benalign"
  const isBennie = search === "?bennie"

  useEffect(() => {
    if (
      !invite_code &&
      invite_code !== props.invite_code &&
      props.invite_code !== ""
    ) {
      setInvite_code(props.invite_code)
    }
  }, [props.invite_code, invite_code])

  const selectPlan = plan => {
    setSelectedPlan(plan)
    props.setChannelId(plan.channel_id)
  }

  const acceptAgreements = acceptedAgreements =>
    setAcceptedAgreements(acceptedAgreements)

  const {
    match: { url }
  } = props

  const [agreements, { signupUser }] = useStore("agreements")
  const [invitation, { setChannelId }] = useStore("invite", invite_code)
  const { metadata, is_passwordless, status, channel_id, plan_id } = invitation

  const profileInfo = ({ values, is_passwordless }) => (
    <Recaptcha
      action="signup"
      enabled={!(invite_code || (selectedPlan && selectedPlan.amount))}
    >
      {captcha_token => (
        <ProfileInfo
          passwordRequired={!is_passwordless}
          values={values}
          submit={async ({
            confirm_password,
            primary_state_of_residence,
            ...rest
          }) => {
            const signupData = {
              ...rest,
              invite_code: invite_code,
              plan_id: selectedPlan ? selectedPlan.id : null,
              channel_id: selectedPlan ? selectedPlan.channel_id : null,
              agreement_ids: acceptedAgreements,
              captcha_token: captcha_token,
              metadata: {
                primary_state_of_residence
              }
            }
            if (stripe_token) {
              signupData["payment"] = {
                type: "stripe",
                token: stripe_token
              }
            }
            await signupUser(signupData)
            // window.location = "/"
            history.push("/home")
          }}
        />
      )}
    </Recaptcha>
  )

  return (
    <AppLayout>
      <AppLayout.Header logo={<Logo className="no-print" />} isDevEnv={false} />
      <AppLayout.Content>
        <Switch>
          <Route
            key={`${url}/agreements`}
            path={`${url}/agreements`}
            render={() => (
              <Agreements
                agreements={agreements}
                onSuccess={!invite_code ? "/signup/payment" : "/signup/profile"}
                onAllAccept={acceptAgreements}
              />
            )}
          />
          <Route
            key={`${url}/invited`}
            path={`${url}/invited`}
            render={props => {
              return (
                <InviteCode
                  success={<Redirect to={`/signup#${invite_code}`} />}
                  customError={
                    invalidInvite ? "Invite code you entered is invalid" : null
                  }
                />
              )
            }}
          />
          <Route
            key={`${url}/payment`}
            path={`${url}/payment`}
            render={props => {
              if (selectedPlan && selectedPlan.id === "plan_13acH") {
                return <Redirect to={`${url}/profile`} />
              }
              return (
                <StripeCheckout
                  onSubmit={({ stripe_token, email }) => {
                    setStripe_token(stripe_token)
                    return Promise.resolve()
                  }}
                  planName={
                    (selectedPlan.interval || "") +
                    " " +
                    (selectedPlan.name || "") +
                    " Subscription"
                  }
                  interval={selectedPlan.interval}
                  amount={selectedPlan.amount || 0}
                  free_trial_days={selectedPlan.free_trial_days || 0}
                  onSuccess={() => <Redirect to={`${url}/profile`} />}
                />
              )
            }}
          />
          <Route
            key={`${url}/profile`}
            path={`${url}/profile`}
            render={props => {
              if (!invite_code) {
                return profileInfo({})
              }
              return profileInfo({
                values: metadata,
                is_passwordless
              })
            }}
          />
          <Route
            key={`${url}/plans`}
            path={`${url}/plans`}
            render={props => {
              if (invite_code) {
                return <Redirect to={`${url}/overview`} />
              }
              if (selectedPlan) {
                return <Redirect to={`${url}/overview`} />
              }
              return (
                <PlanSelector
                  selectPlan={selectPlan}
                  inviteUrl={`${url}/invited`}
                  plans={plans.filter(plan =>
                    isBenalign
                      ? plan.id === "plan_ba237"
                      : isBennie
                      ? plan.id === "plan_be238"
                      : plan.is_offered &&
                        (!IS_PREMIUM || plan.is_payment_required)
                  )}
                  showAlternatives={!(isBenalign || isBennie)}
                />
              )
            }}
          />
          <Route
            key={`${url}/overview`}
            path={`${url}/overview`}
            render={props => {
              if (
                selectedPlan &&
                (selectedPlan.id === "plan_COVID" ||
                  selectedPlan.id === "plan_VYCVD")
              ) {
                return (
                  <OverviewCOVID
                    plan={selectedPlan}
                    nextUrl={`${url}/agreements`}
                  />
                )
              }
              if (invite_code) {
                return (
                  <OverviewInvited
                    plan={selectedPlan}
                    nextUrl={`${url}/agreements`}
                  />
                )
              } else if (!selectedPlan) {
                return <Redirect to={`${url}/plans`} />
              }
              if (selectedPlan.id === "plan_13acH") {
                return (
                  <OverviewDirectFree
                    plan={selectedPlan}
                    nextUrl={`${url}/agreements`}
                    upgradePlan={() =>
                      setSelectedPlan(
                        plans.find(({ id }) => id === "plan_p0RQI")
                      )
                    }
                    baseUrl={url}
                  />
                )
              }
              if (selectedPlan.id === "plan_m0acH") {
                return (
                  <OverviewDirectPersonal
                    plan={selectedPlan}
                    nextUrl={`${url}/agreements`}
                  />
                )
              }
              return (
                <OverviewDirectPaid
                  plan={selectedPlan}
                  nextUrl={`${url}/agreements`}
                />
              )
            }}
          />
          <Route
            key={`${url}/employer`}
            path={`${url}/employer`}
            render={() => <FindYourEmployer nextUrl={`${url}/plans`} />}
          />
          <Route
            key={`${url}`}
            path={`${url}`}
            render={() => {
              if (invite_code) {
                if (status !== "valid") {
                  setInvalidInvite(true)
                  return <Redirect to={`${url}/invited`} />
                }
                if (channel_id) {
                  setChannelId(channel_id)
                }
                if (!selectedPlan || selectedPlan.id !== plan_id) {
                  window.setTimeout(
                    () =>
                      setSelectedPlan(
                        plans.find(({ id }) => id === plan_id) || {
                          id: plan_id,
                          channel_id
                        }
                      ),
                    0
                  )
                }
                setInvalidInvite(false)
                return <Redirect to={`${url}/overview`} />
              }
              return <Redirect to={`${url}/plans`} />
            }}
          />
          <Redirect to={`${url}`} />
        </Switch>
      </AppLayout.Content>
      <AppLayout.Footer disclosure={<TermsofUse />} />
    </AppLayout>
  )
}

const Signup = withRouter(props => {
  const { setChannelId } = useStore()
  return <SignupContainer setChannelId={setChannelId} {...props} />
})

export default Signup
